/** Google Drive's logo URL. Kept separate from `google-drive-ai`'s registration
 * so the MCP server spec can use it without registering the integration. */
export const GoogleDriveAiIconUrl =
  "https://fonts.gstatic.com/s/i/productlogos/drive_2020q4/v8/192px.svg";
